import { render, staticRenderFns } from "./CardBaseComponent.vue?vue&type=template&id=72a439e9&scoped=true&"
import script from "./CardBaseComponent.vue?vue&type=script&lang=ts&"
export * from "./CardBaseComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CardBaseComponent.vue?vue&type=style&index=0&id=72a439e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a439e9",
  null
  
)

export default component.exports